import { Contact, ContactsFilter } from './models/contacts';

export function matchesContactFilter(contact: Contact, filter: ContactsFilter): boolean {
  if (filter.type && contact.type !== filter.type) {
    return false;
  }
  const search = filter.search;
  if (search?.value) {
    const value = search.value.toLowerCase();
    // A missing/null field (e.g. no job title) must simply fail to match — falling back to a
    // combined search here would silently ignore the column the user scoped the search to.
    const record = contact as unknown as Record<string, unknown>;
    const haystack = search.columnName
      ? String(record[search.columnName] ?? '')
      : `${contact.displayName} ${contact.email} ${contact.jobTitle}`;
    if (!haystack.toLowerCase().includes(value)) {
      return false;
    }
  }
  return true;
}
